import { MissionSummaryMission, MissionSummary } from '@edwin-group/cj-graphql';
import { Bar } from 'react-chartjs-2';
import { useMemo } from 'react';
import { getStackedBarOptions } from './options';
import { parseMissionSummary } from './parse';
import useIsMobile from '@/hooks/useIsMobile';
import { Chart as ChartJS, Tooltip, Legend, Title, BarElement, CategoryScale, LinearScale } from 'chart.js';

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend, Title);

export const Chart = ({
  missionSummary,
  missionSelected,
}: {
  missionSummary: MissionSummary;
  missionSelected: string | null;
}) => {
  const { isMobile } = useIsMobile();

  const options = useMemo(() => getStackedBarOptions(isMobile), [isMobile]);

  const chartData = useMemo(
    () => parseMissionSummary(missionSummary?.missions as MissionSummaryMission[], missionSelected),
    [missionSummary?.missions, missionSelected],
  );

  return (
    <Bar
      data={{
        labels: chartData.labels,
        datasets: chartData.datasets,
      }}
      options={options}
      className="!m-0 !my-sh-15 max-h-96 !p-0"
    />
  );
};
